<template>
  <v-container>
    <v-responsive
      class="mx-auto px-3 px-md-12"
      max-width="750"
    >
      <div
        class="text-center"
        width="100%"
      >
        <div
          v-if="productsPurchased"
          width="100%"
        >
          <h1>
            Your Products
          </h1>
          <div v-if="annaliisPurchased">
            <h2>
              Annaliis
            </h2>
            <br>
            <v-img
              class="mx-auto"
              height="15vh"
              width="15vh"
              :src="require('../../../assets/AnnaliisA.png')"
            />
            <br>
            <h4>There is no separate file for the unlocked version - just unlock the demo by entering your license on the padlock icon in Annaliis.</h4>
            <br>
            <h3
              v-if="annaliisLicensesVisible"
              width="100%"
            >
              {{ this.$store.getters.unlock }}
            </h3>
            <h3 v-else>
              XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
            </h3>
            <br>
            <v-btn
              v-if="userIsAuthenticated"
              primary
              accent
              width="290"
              height="44"
              class="mb-3"
              @click="fetchAnnaliisLicenses"
            >
              {{ annaliisLicensesVisible ? 'Hide license' : 'Show license' }}
            </v-btn>
          </div>
          <br>
          <div v-if="mesArpPurchased">
            <h2>
              MES Arpeggiator
            </h2>
            <br>
            <v-img
              class="mx-auto"
              height="15vh"
              width="15vh"
              :src="require('../../../assets/MESArp.png')"
            />
            <br>
            <h4>There is no separate file for the unlocked version - just unlock the demo by entering your license in MES Arpeggiator.</h4>
            <br>
            <h3
              v-if="mesArpLicensesVisible"
              width="100%"
            >
              {{ this.$store.getters.mesArpUnlock }}
            </h3>
            <h3 v-else>
              XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
            </h3>
            <br>
            <v-btn
              v-if="userIsAuthenticated"
              primary
              accent
              width="290"
              height="44"
              class="mb-3"
              @click="fetchMesArpLicenses"
            >
              {{ mesArpLicensesVisible ? 'Hide license' : 'Show license' }}
            </v-btn>
          </div>
        </div>
        <div v-else>
          <h1>
            Your Products
          </h1>
          <br>
          <h2>
            You do not currently own any MES<sup>&reg;</sup> products.
          </h2>
          <br>
          <div class="cta-buttons">
            <button
              style="width: 320px; height: 44px; text-transform: none;"
              class="cta-button download-button"
              @click="handleButtonClick('Buy')"
            >
              Buy Annaliis/ MES Arp
            </button>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button
          v-if="userIsAuthenticated"
          style="width: 320px; height: 44px; text-transform: none;"
          margin-top="300px"
          width="290"
          height="44"
          class="cta-button-blue download-button"
          primary
          accent
          large
          @click="signOut"
        >
          Sign out
        </button>
      </div>
    </v-responsive>
  </v-container>
</template>
  <script>
  import DownloadButtons from './DownloadButtons.vue'
  import { EventBus } from '@/event-bus.js'
  export default {
    inject: ['eventBus'],
    data () {
      return {
        footerVisibleLogged: false, // Flag to track if the 'Stripe Button Seen' event has been logged
        annaliisLicensesVisible: false,
        mesArpLicensesVisible: false
      }
    },
    computed: {
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      productsPurchased () {
        return this.$store.getters.purchased || this.$store.getters.mesArpPurchased
      },
      annaliisPurchased () {
        return this.$store.getters.purchased
      },
      mesArpPurchased () {
        return this.$store.getters.mesArpPurchased
      }
    },
    beforeMount () {
      this.$store.dispatch('getUserData', { user: this.$store.getters.user })
    },
    mounted () {
      this.eventBus.$on('footer-visible', this.handleFooterVisible)

      // Call getUserData immediately when the component is mounted
      this.fetchUserData()

      // Set up an interval to call getUserData every few seconds
      this.userDataInterval = setInterval(this.fetchUserData, 3000) // 3000 milliseconds = 3 seconds
    },
    beforeDestroy () {
      // Clear the interval when the component is about to be destroyed
      clearInterval(this.userDataInterval)
    },
    methods: {
      isUserLoggedIn () {
        return this.$store.getters.isUserLoggedIn
      },
      handleButtonClick (buttonType) {
        this.$router.push({ name: 'Buy' })
        const userStatus = this.isUserLoggedIn() ? 'user logged in' : 'user not logged in'
        // trackEvent({
        //   event: `${buttonType} Button Hit`,
        //   event_category: 'Button Clicks',
        //   event_action: `Click - ${userStatus}`,
        //   event_label: buttonType
        // })
      },
      isUserAreaActive () {
        return this.$route.name === 'User Area'
      },
      handleFooterVisible () {
        if (this.userIsAuthenticated && this.isUserAreaActive() && !this.footerVisibleLogged) {
          // trackEvent({
          //   event: 'Stripe Button Seen',
          //   event_category: 'Visibility',
          //   event_action: 'Scroll',
          //   event_label: 'Stripe Button Seen'
          // })
          this.footerVisibleLogged = true // Set the flag to true after logging the event
        }
      },
      signOut () {
        this.$store.dispatch('signUserOut')
        this.$router.push('/')
        // trackEvent({
        //   event: 'Sign Out Button Hit',
        //   event_category: 'Button Clicks',
        //   event_action: 'Click',
        //   event_label: 'User Signed Out'
        // })
      },
      fetchAnnaliisLicenses () {
        this.annaliisLicensesVisible = !this.annaliisLicensesVisible
        // trackEvent({
        //   event: 'Show Hide License Button Hit',
        //   event_category: 'Button Clicks',
        //   event_action: 'Click',
        //   event_label: 'Toggle License Visibility'
        // })
      },
      fetchMesArpLicenses () {
        this.mesArpLicensesVisible = !this.mesArpLicensesVisible
      },
      fetchUserData () {
        // Dispatch the getUserData action
        this.$store.dispatch('getUserData', { user: this.$store.getters.user })
      },
    },
  }
  </script>

<style scoped>
.cta-buttons {
  display: flex;
  justify-content: center; /* Centering the buttons */
  padding: 20px;
  gap: 20px; /* Adds space between buttons */
}

.cta-button {
  padding: 10px 40px; /* Increased horizontal padding */
  border: none;
  border-radius: 5px;
  font-size: 18px; /* Slightly larger font size */
  cursor: pointer;
  transition: background-color 0.3s;
  min-width: 150px; /* Minimum width */
  background-color: #4CAF50; /* Green */
  color: white;
}

.cta-button-blue {
  padding: 10px 40px; /* Increased horizontal padding */
  border: none;
  border-radius: 5px;
  font-size: 18px; /* Slightly larger font size */
  cursor: pointer;
  transition: background-color 0.3s;
  min-width: 150px; /* Minimum width */
  background-color: #0074d4;
  color: white;
}

.cta-button:hover {
  opacity: 0.9;
}

/* Button styles */
button {
  margin: 10px;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
}
</style>
